import { render } from "./ProductPanel.vue?vue&type=template&id=664535c2&scoped=true"
import script from "./ProductPanel.vue?vue&type=script&lang=js"
export * from "./ProductPanel.vue?vue&type=script&lang=js"

import "./ProductPanel.vue?vue&type=style&index=0&id=664535c2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664535c2"]])

export default __exports__